import Axios from "@/plugins/Axios";

export class ImageServices {
  async uploadImage(url, file, id) {
    const formData = new FormData();
    formData.append("file", file);
    Axios().interceptors.request.use((config) => {
      config.headers["Content-Type"] = "multipart/form-data";
      return config;
    });
    const response = await Axios().post(`${url}/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  }

  async downloadImage(url) {
    const { base64, tipo } = await Axios()
      .get(url, { responseType: "arraybuffer" })
      .then((response) => ({
        base64: Buffer.from(response.data, "binary").toString("base64"),
        tipo: response.headers["content-type"],
      }));
    const mime = tipo && tipo.startsWith("image/") ? tipo : "image/jpeg";
    return `data:${mime};base64, ${base64}`;
  }
}
export default new ImageServices();
